const baseURL = 'https://api.shecodes.io/weather/v1';
const key = 'd1f3fa1bbd2e0t6f3b4o3faabd9a8d79&units=metric';

export default baseURL;

export const urls = {
    current: `/current?`,
    forecast: `/forecast?`,
    key:key

};